import React, { ReactNode, useState } from 'react';

import { closeIcon } from '@justgiving/icons';
import Loader from '@justgiving/loading/es/Loading';
import Svg from '@justgiving/svg';

import usePageViewTracking, {
  PageViewTrackingProps,
} from '../../hooks/usePageViewTracking';
import Button from '../Button/Button';

import styles from './ConfirmationModal.scss';

export interface ConfirmationModalProps {
  children?: ReactNode;
  onConfirm: () => void;
  onDismiss: () => void;
  confirmButtonText: string;
  dismissButtonText: string;
  modalTitle: string;
  pageViewTrackingData?: PageViewTrackingProps;
}

export const ConfirmationModal = React.forwardRef(
  (
    {
      children,
      modalTitle,
      onDismiss,
      onConfirm,
      confirmButtonText,
      dismissButtonText,
      pageViewTrackingData,
    }: ConfirmationModalProps,
    ref?: React.Ref<HTMLDivElement>,
  ) => {
    const [confirmationGiven, setConfirmationGiven] = useState(false);
    usePageViewTracking(pageViewTrackingData);

    const handleConfirmation = () => {
      setConfirmationGiven(true);
      onConfirm();
    };

    return (
      <div
        aria-label={modalTitle}
        className={`${styles.confirmationModal} jg-display-flex jg-flex-column jg-flex-ais`}
        ref={ref}
      >
        <header className="jg-display-flex jg-flex-column jg-flex-asc ">
          <Svg
            markup={closeIcon}
            aria-label={'closeIcon'}
            className={`${styles.closeIcon} jg-flex-ase`}
            onClick={confirmationGiven ? () => {} : onDismiss}
          />
          <span className={`${styles.title} jg-flex-asc`}>{modalTitle}</span>
        </header>
        {children}

        <Button
          className="jg-btn jg-space-mtmd"
          onClick={handleConfirmation}
          type="button"
          disabled={confirmationGiven}
        >
          {confirmationGiven ? (
            <Loader size="small" colour="white" />
          ) : (
            confirmButtonText
          )}
        </Button>

        <Button
          className="jg-btn--ghost jg-space-mtms"
          onClick={onDismiss}
          type="button"
          disabled={confirmationGiven}
        >
          {dismissButtonText}
        </Button>
      </div>
    );
  },
);

ConfirmationModal.displayName = 'ConfirmationModal';

export default ConfirmationModal;
